import { TextColor, TitleSize } from '@api/selections';
import { Typography, TypographyProps, styled } from '@mui/material';
import { palette } from '@themes/theme.helpers';
import classnames from 'classnames';

// STYLES
//--------

const TitleWrapper = styled(Typography)<TypographyProps>`
  // Color options
  // Uses text color by default, but can be overridden to use black or white
  &.black {
    color: ${palette.text('primary')};
  }
  &.white {
    color: ${palette.common('white')};
  }
`;

// TYPES
//-------
export type MainTitleProps = Pick<TypographyProps, 'children' | 'sx' | 'className'> & {
  text?: string;
  variant?: TitleSize;
  color?: TextColor;
  regular?: boolean;
  noDot?: boolean;
};

/**
 * Main title to be used as header
 */
export const Title = ({
  children,
  text,
  variant = 'h1',
  color = 'black',
  className,
  regular,
  noDot,
  sx,
  ...rest
}: MainTitleProps) => {
  const hasContent = children || text;
  const mainClassName = classnames('main-title', variant, color, className, {
    regular: regular,
    'no-dot': noDot,
  });
  if (!hasContent) {
    return null;
  }
  return (
    <TitleWrapper {...rest} variant={variant} className={mainClassName} sx={sx}>
      {children || text}
    </TitleWrapper>
  );
};
